/* Ice Secret quick add, shared by the IS shopping cards (best sellers, monthly specials).
   Markup comes from snippets/is-qa.liquid. One product with one variant adds straight from
   the + button; anything with sizes opens a small sheet to pick one first. */
(function(){
  if(window.__isQA) return; window.__isQA=true;

  function fmt(cents,f){
    f=f||('$'+'{{amount}}');
    function n(c,d,t,s){ var v=(c/100).toFixed(d), p=v.split('.'); p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,t); return p.join(d?s:''); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){
      if(k==='amount_no_decimals') return n(cents,0,',','.');
      if(k==='amount_with_comma_separator') return n(cents,2,'.',',');
      if(k==='amount_no_decimals_with_comma_separator') return n(cents,0,'.',',');
      return n(cents,2,',','.');
    }).replace(/<[^>]*>/g,'');
  }
  function bumpCount(){
    ['cart:refresh','cart:updated','theme:cart:refresh','theme:cart:reload'].forEach(function(n){ document.dispatchEvent(new CustomEvent(n,{bubbles:true})); });
    fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js').then(function(r){return r.json()}).then(function(c){
      [].forEach.call(document.querySelectorAll('[data-is-cart-count]'),function(el){ el.textContent=c.item_count; el.hidden=c.item_count===0; });
      document.dispatchEvent(new CustomEvent('is:cart',{detail:c}));
    }).catch(function(){});
  }
  function add(id){
    return fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:1}]})}).then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); });
  }
  function closeAll(except){
    [].forEach.call(document.querySelectorAll('[data-isqa].on'),function(q){ if(q!==except){ q.classList.remove('on'); var b=q.querySelector('[data-isqa-open]'); b&&b.setAttribute('aria-expanded','false'); var c=q.closest('[data-isqa-card]'); c&&c.classList.remove('qa-on'); } });
  }

  function wire(q){
    if(q.__w) return; q.__w=true;
    var data; try{ data=JSON.parse(q.querySelector('[data-isqa-json]').textContent); }catch(e){ return; }
    var vs=data.v||[], pct=data.m||0, mf=data.f;
    var opens=[].slice.call(q.querySelectorAll('[data-isqa-open]'));
    var pop=q.querySelector('[data-isqa-pop]');
    var groups=pop?[].slice.call(pop.querySelectorAll('[data-opt]')):[];
    var pr=pop&&pop.querySelector('[data-pr]'), mem=pop&&pop.querySelector('[data-mem]'), btn=pop&&pop.querySelector('[data-add]'), err=pop&&pop.querySelector('[data-err]');
    function sel(){ return groups.map(function(g){ var on=g.querySelector('button.on'); return on?on.getAttribute('data-v'):null; }); }
    function match(){ var s=sel(); return vs.filter(function(v){ return s.every(function(x,i){ return x===null||v.o[i]===x; }); })[0]||vs[0]; }
    function sync(){
      if(!pop) return; var v=match(); if(!v) return;
      pr.textContent=fmt(v.p,mf); if(mem) mem.textContent=fmt(Math.round(v.p*(100-pct)/100),mf);
      btn.disabled=!v.a; btn.textContent=v.a?btn.getAttribute('data-l'):btn.getAttribute('data-so');
      var s=sel();
      groups.forEach(function(g,gi){ [].forEach.call(g.querySelectorAll('button'),function(b){
        var val=b.getAttribute('data-v');
        var ok=vs.some(function(x){ return x.a && x.o[gi]===val && s.every(function(y,yi){ return yi===gi||y===null||x.o[yi]===y; }); });
        b.classList.toggle('na',!ok);
      }); });
    }
    groups.forEach(function(g){ g.addEventListener('click',function(e){ var b=e.target.closest('button'); if(!b) return;
      [].forEach.call(g.querySelectorAll('button'),function(x){ x.classList.toggle('on',x===b); }); sync(); }); });

    function flash(el,ok,msg){
      el.classList.remove('busy'); el.classList.add(ok?'ok':'bad');
      if(msg) el.setAttribute('data-msg',msg);
      setTimeout(function(){ el.classList.remove('ok','bad'); el.removeAttribute('data-msg'); },ok?1800:2600);
    }

    opens.forEach(function(o){
      o.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation();
        if(!pop || o.hasAttribute('data-isqa-direct')){
          var v=vs.filter(function(x){return x.a})[0]; if(!v){ flash(o,false,o.getAttribute('data-so')); return; }
          if(o.classList.contains('busy')) return; o.classList.add('busy');
          add(v.id).then(function(){ flash(o,true); bumpCount(); }).catch(function(j){ flash(o,false,(j&&(j.description||j.message))||''); });
          return;
        }
        var on=!q.classList.contains('on'); closeAll(q);
        q.classList.toggle('on',on); o.setAttribute('aria-expanded',on?'true':'false');
        var c=q.closest('[data-isqa-card]'); c&&c.classList.toggle('qa-on',on);
        pop.classList.remove('done'); if(err) err.textContent='';
        if(on){ var f=pop.querySelector('button:not([disabled])'); f&&f.focus({preventScroll:true}); }
      });
    });
    if(pop){
      pop.addEventListener('click',function(e){ e.stopPropagation(); if(e.target.closest('[data-close]')) closeAll(null); });
      btn.addEventListener('click',function(){
        var v=match(); if(!v||!v.a) return; btn.disabled=true; btn.textContent=btn.getAttribute('data-ing');
        add(v.id).then(function(){
          var w=pop.querySelector('[data-what]'); if(w) w.textContent=sel().filter(Boolean).join(' · ');
          pop.classList.add('done'); bumpCount();
        }).catch(function(j){ if(err) err.textContent=(j&&(j.description||j.message))||'Could not add. Please try again.'; })
          .then(sync);
      });
      sync();
    }
  }
  function scan(root){ [].forEach.call((root||document).querySelectorAll('[data-isqa]'),wire); }
  window.ISQA={scan:scan,fmt:fmt};
  document.addEventListener('click',function(){ closeAll(null); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(null); });
  document.addEventListener('shopify:section:load',function(e){ scan(e.target); });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ scan(); }); else scan();
})();
